// Role names shown in the role switcher and user menu (frontend/src/components/Layout/Layout.js).
// Role names come from the roles table and may be stored in English or Swahili.
const rolesDict = [
  { en: "Switch role", sw: "Badilisha nafasi" },
  { en: "Secretary", sw: "Katibu" },
  { en: "Chair", sw: "Mwenyekiti" },
  { en: "Treasurer", sw: "Mweka Hazina" },
  { en: "Admin", sw: "Msimamizi" },
  { en: "Administrator", sw: "Msimamizi Mkuu" },
];

export default rolesDict;
